export default __webpack_public_path__ + "static/media/Hallticket5.56cab01d.jpg";